import { useEffect, useRef, useState } from "react";

let apiPromise;
export const loadYouTubeApi = () => {
  if (!apiPromise) {
    apiPromise = new Promise((resolve) => {
      if (window.YT?.Player) return resolve(window.YT);
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        prev?.();
        resolve(window.YT);
      };
      const s = document.createElement("script");
      s.src = "https://www.youtube.com/iframe_api";
      document.head.appendChild(s);
    });
  }
  return apiPromise;
};

const PLAYING = 1;
const BUFFERING = 3;

// Tries autoplay with sound; falls back to muted autoplay when the browser blocks sound.
export const useYouTubeAutoplay = (iframeRef, videoKey) => {
  const playerRef = useRef(null);
  const [mutedFallback, setMutedFallback] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let timer;
    let errored = false;
    setMutedFallback(false);
    loadYouTubeApi().then((YT) => {
      if (cancelled || !iframeRef.current) return;
      playerRef.current = new YT.Player(iframeRef.current, {
        events: {
          onError: () => {
            errored = true;
            clearTimeout(timer);
            setMutedFallback(false);
          },
          onReady: (e) => {
            if (errored) return;
            e.target.playVideo();
            timer = setTimeout(() => {
              if (errored) return;
              const state = e.target.getPlayerState();
              if (state !== PLAYING && state !== BUFFERING) {
                e.target.mute();
                e.target.playVideo();
              }
              if (e.target.isMuted()) setMutedFallback(true);
            }, 1500);
          },
        },
      });
    });
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [iframeRef, videoKey]);

  const unmute = () => {
    const p = playerRef.current;
    if (!p) return;
    p.unMute();
    p.setVolume(100);
    p.playVideo();
    setMutedFallback(false);
  };

  return { mutedFallback, unmute };
};
